export const PAGE = {
  TITLE: 'title',
  HOME: 'home',
  SETUP_NAME: 'setupName',
  SETUP_COUNTRY: 'setupCountry',
  SETUP_ROLE: 'setupRole',
  OPTIMISATION_LAB: 'optimisationLab',
  GAME: 'game',
  HIGH_SCORES: 'highscores',
  DAILY_HIGH_SCORES: 'dailyHighScores',
  ALL_TIME_HIGH_SCORES: 'allTimeHighScores'
};

export const ROLE = {
  STUDENT: 'student',
  ACADEMIC: 'academic',
  PROFESSIONAL: 'professional',
  GOVERNMENT: 'government',
  OTHER: 'other'
};

export const ROLE_LABEL = {
  [ROLE.STUDENT]: 'Student',
  [ROLE.ACADEMIC]: 'Academic / Researcher',
  [ROLE.PROFESSIONAL]: 'Energy Professional',
  [ROLE.GOVERNMENT]: 'Government / Policy Maker',
  [ROLE.OTHER]: 'Other'
};

export const ROLES = Object.values(ROLE);
